import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { isGulpOrBranching } from 'owa-config';
import type { OfflineDisabledReason } from './OfflineDisabledReason';
import { isRecurringDevice } from './recurringDevice';

export function isOfflineSyncAvailable(): boolean {
    return getOfflineSyncUnavailableReason() === undefined;
}

export function getOfflineSyncUnavailableReason(): OfflineDisabledReason | undefined {
    const reason = getOfflineSyncUnavailableReasonCommon();
    if (reason !== 'continue') {
        return reason;
    }

    return getOfflineSyncUnavailableReasonDueToPolicy();
}

function getOfflineSyncUnavailableReasonCommon(): OfflineDisabledReason | 'continue' {
    /* eslint-disable-next-line no-restricted-properties -- (https://aka.ms/OWALintWiki)
     * need to use indexedDB.databases to workaround Dexie version handling */
    if (!self.BroadcastChannel || !self.indexedDB?.databases) {
        return 'LegacyBrowser';
    }

    if (!isAnyOfflineModuleEnabled()) {
        return 'FeatureFlags';
    }

    return 'continue';
}

export function getOfflineSyncUnavailableReasonDueToPolicy(): OfflineDisabledReason | undefined {
    const policies = getUserConfiguration().PolicySettings;

    /*
    offlineDataAllowed is only enabled for native
    localCacheAllowed is only enabled for web
    */
    if (isHostAppFeatureEnabled('offlineDataAllowed')) {
        return !policies?.OfflineEnabledWin ? 'Policy' : undefined;
    }

    if (isHostAppFeatureEnabled('localCacheAllowed')) {
        if (isGulpOrBranching()) {
            return undefined;
        }

        if (!policies?.OfflineEnabledWeb) {
            return 'Policy';
        }

        if (!policies?.SignInState?.includes('kmsi')) {
            return 'DataNotAllowed';
        }

        // Avoid caching data on one-off devices (kiosks, borrowed machines, incognito).
        // Ripcord: the flight disables the recurring-device requirement
        if (
            !isGlobalFeatureEnabled('fwk-offline-recurring-device-only-ripcord') &&
            !isRecurringDevice()
        ) {
            return 'NotRecurringDevice';
        }

        return undefined;
    }

    return 'DataNotAllowed';
}

function isAnyOfflineModuleEnabled() {
    return (
        isGlobalFeatureEnabled('fwk-offline-mail') ||
        isGlobalFeatureEnabled('fwk-offline-calendar') ||
        isGlobalFeatureEnabled('peo-offline') ||
        isGlobalFeatureEnabled('peo-offline-via-pdv') ||
        isGlobalFeatureEnabled('peo-offline-shadow-pdv') ||
        isGlobalFeatureEnabled('msplaces-offline')
    );
}
